let allBenefits = document.querySelectorAll('[data-show-image]');

allBenefits.forEach((benefit) => {
    if (window.innerWidth > 990) {
        benefit.addEventListener('mouseover', function (e) {
            let imgSelector = e.target.getAttribute('data-show-image');
            document.querySelector('.main-benefit-image').classList.add('fade-out');
            document.querySelector(`[data-image="${imgSelector}"]`).classList.add('show-benefit');
        });

        benefit.addEventListener('mouseout', function (e) {
            let imgSelector = e.target.getAttribute('data-show-image');
            document.querySelector('.main-benefit-image').classList.remove('fade-out');
            document.querySelector(`[data-image="${imgSelector}"]`).classList.remove('show-benefit');
        });
    }
});